import { MealType } from '@akin-home/amplify';
import { Text } from '@akin-home/text/native';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-native-fontawesome';
import styled from 'styled-components/native';

interface Props {
  text: string;
  meal_type: MealType;
  onPress(meal_type: MealType): void;
}

export const TimeButton = ({ text, meal_type, onPress }: Props) => {
  const handlePress = () => onPress(meal_type);

  return (
    <Container onPress={handlePress}>
      <FontAwesomeIcon icon={clock_icon} />
      <ButtonText weight="semibold">{text}</ButtonText>
      <FontAwesomeIcon icon="chevron-right" />
    </Container>
  );
};

const clock_icon: IconProp = ['far', 'clock'];

const Container = styled.TouchableOpacity`
  flex-direction: row;
  align-items: center;

  justify-content: space-between;
  padding: 12px;
  border-radius: 15px;
  border-width: 2px;
  border-color: rgba(5, 22, 51, 0.1);
`;

const ButtonText = styled(Text)`
  font-size: 15px;
`;
